import { createAction } from "redux-starter-kit";
import {
  ARTICLE_LIST_START_LOAD,
  ARTICLE_LIST_END_LOAD,
  ARTICLE_LIST_LOAD_FAIL,
  ARTICLE_LIST_UPDATE_AN_ARTICLE_META
} from "../actionTypes";

import { getArticlesApi, updateArticlesMetaApi } from "../../api/articles";

export const startLoadArticlesAction = createAction(ARTICLE_LIST_START_LOAD);
export const endLoadArticlesAction = createAction(ARTICLE_LIST_END_LOAD);
export const articlesFailLoadAction = createAction(ARTICLE_LIST_LOAD_FAIL);
export const updateAnArticleMetaAction = createAction(
  ARTICLE_LIST_UPDATE_AN_ARTICLE_META
);

export function loadArticlesRequestAction(issueID, isPdf) {
  return async dispatch => {
    dispatch(startLoadArticlesAction({ issueID, isPdf }));

    try {
      let articles = await getArticlesApi(issueID, isPdf);

      dispatch(endLoadArticlesAction({ issueID, isPdf, articles }));
    } catch (e) {
      dispatch(
        articlesFailLoadAction({ issueID, isPdf, errMsg: e.toString() })
      );
    }
  };
}

export function updateArticlesMetaDataRequestAction(issueID, isPdf, metaData) {
  return async dispatch => {
    dispatch(startLoadArticlesAction({ issueID, isPdf }));

    try {
      await updateArticlesMetaApi(issueID, isPdf, metaData);
      let articles = await getArticlesApi(issueID, isPdf);

      dispatch(endLoadArticlesAction({ issueID, isPdf, articles }));
    } catch (e) {
      dispatch(
        articlesFailLoadAction({ issueID, isPdf, errMsg: e.toString() })
      );
    }
  };
}
